/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Failed_Load_FoldersInputs */

const en_audio_failed_load_folders = /** @type {(inputs: Audio_Failed_Load_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load folders`)
};

const es_audio_failed_load_folders = /** @type {(inputs: Audio_Failed_Load_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar las carpetas`)
};

/**
* | output |
* | --- |
* | "Failed to load folders" |
*
* @param {Audio_Failed_Load_FoldersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_failed_load_folders = /** @type {((inputs?: Audio_Failed_Load_FoldersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Failed_Load_FoldersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_failed_load_folders(inputs)
	return en_audio_failed_load_folders(inputs)
});